// extracted by mini-css-extract-plugin
export default {"cls1":"SeasonalDiscountUnibrow-cls1_TJU","cls2":"SeasonalDiscountUnibrow-cls2_nOG SeasonalDiscountUnibrow-cls1_TJU"};